import { StepHandle } from "..";
import { pictureStepService } from "../../services/steps/picture";
import { PictureStepData, Step } from "../../types";
import { WorkflowManager } from "../../WorkflowManager";
import { Variant } from "../resource/variant";

export class PictureStepHandle extends StepHandle<PictureStepData> {
    constructor(manager: WorkflowManager, step: Step<PictureStepData>, tags: string[]) {
        super(manager, step, tags);
    }
    /**
     * Allows the user to select an image variant from the available variants configured on this steps base option.
     * @param variant The new image variant to use.
     * @returns A promise that can be awaited to ensure the new image asset has been updated on the design.
     */
    selectVariant(variant: Variant) {
        return pictureStepService.selectVariant(this.step, variant.getResource(), this.manager, (v) =>
            this.setUpdateState(v),
        );
    }
}
